var map = {
	"./tag1.png": 8085,
	"./tag1active.png": 7718,
	"./tag2.png": 5747,
	"./tag2active.png": 2220,
	"./tag3.png": 8128,
	"./tag3active.png": 1745,
	"./tag4.png": 7219,
	"./tag4active.png": 6554,
	"./tagBg.png": 187,
	"./tagBgActive.png": 7603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9360;